import { IHolidaysModalPropsForQappAdmin } from "./HolidaysModalTypesForQappAd"

import { useUI } from "providers/UIProvider"
import { Container, Flex } from "@chakra-ui/react"
import Modal from "components/UI/organisms/Modal"
import AddAdminEditHolidayModal from "../AddAdminEditHolidayModal"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import useAdminHolidays from "hooks/useAdminHolidays"
import CompanyBranchesForHolidays from "components/shared/CompanyBranches/CompanyBranchesForHolidays"
import HolidayItemForQappAdmin from "./HolidayItemForQappAdmin"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { IAdminLaundryHoliday } from "types/laundry"

const HolidaysModalForQappAdmin: React.FC<IHolidaysModalPropsForQappAdmin> = () => {
    const { modals, toggleModal, T } = useUI()
    const { handleAddAdminEditClick, handleDeleteClick } = useAdminHolidays(null)
    const { selectedBranchesForHolidays, adminHolidays } = useAppContext()
    return (
        <Modal
            isOpen={modals.holidaysModalForQappAdmin.isOpened}
            onClose={() => toggleModal("holidaysModalForQappAdmin", false)}
            title={T("general.holiday")}
            styles={{
                headerPadding: "15px 15px 15px 25px",
                bodyPadding: "16px 120px 15px 1px",
                width: "640px",
            }}
        >
            <>

                <Container height="lg" style={{
                    display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", gap: 20
                }}>
                    <CompanyBranchesForHolidays width="250px" />
                    {adminHolidays?.data.map((holiday: IAdminLaundryHoliday) => (
                        <HolidayItemForQappAdmin fromDate={holiday.fromDateTime} toDate={holiday.toDateTime}
                            key={holiday.id} holiday={holiday} logoUrl={holiday.carWashLogoUrl} carWashAddress={holiday.carWashAddress}
                            carWashName={holiday.carWashName}
                            handleDeleteClick={handleDeleteClick}
                            handleEditClick={handleAddAdminEditClick} />
                    ))}

                    <Flex style={{
                        width: "100%",
                        height: "100%",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                        alignItems: "flex-end",
                    }}>
                        {adminHolidays.data?.length === 0 && (
                            <Flex style={{ width: "380px", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                {T("general.empty_states.no_holidays_found")}
                            </Flex>
                        )}
                        <Button
                            marginBottom="1.2rem"
                            isDisabled={selectedBranchesForHolidays.length === 0}
                            _hover={{ backgroundColor: "#7D90A8" }}
                            text={T("general.add_holiday")}
                            onClick={() => handleAddAdminEditClick(null)}
                            leftIcon={
                                <Icon
                                    name="add_circle"
                                    iconStyles={{ width: "40px", height: "40px" }}
                                />
                            }
                            variant={"solid_dark_gray"}
                            styles={{
                                fontSize: "xl", width: "380px",
                                height: selectedBranchesForHolidays.length === 0 ? "103.7px" : "80px"
                            }}
                        />
                    </Flex>


                    <AddAdminEditHolidayModal />
                </Container>

            </>
        </Modal>
    )
}

export default HolidaysModalForQappAdmin
